/** biome-ignore-all lint/complexity/noBannedTypes: tech debt */
import { useCallback, useState } from 'react';

/**
 * @function useFunctionAsState
 * @desc  a hook to help manage state variables that are function and bypass the lazy initialization mechanism of useState
 * @desc  inspired from https://github.com/facebook/react/issues/14087#issuecomment-574060340
 */

export type SetFunctionAsState = (newFn: Function) => void;

export default (fn: Function): [Function, SetFunctionAsState] => {
  const [val, setVal] = useState(() => fn);

  const setFunc = useCallback((newFn: Function) => {
    setVal(() => newFn);
  }, []);

  return [val, setFunc];
};
